import { render } from "./EventCreate.vue?vue&type=template&id=a747723e"
import script from "./EventCreate.vue?vue&type=script&lang=js"
export * from "./EventCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__